export default class SpaAds
{


	constructor ()
	{


		this.adsName                 = 'spa-seen-ads';
		this.delayBeforeShowingAgain = 72; // in hours


		this.getLocalStorageAds();
	}


	getLocalStorageAds ()
	{
		this.ads = JSON.parse( localStorage.getItem( this.adsName ) );
		if ( this.ads === null )
		{
			this.ads = [];
			this.saveLocalStorageAds();
		}

	}

	saveLocalStorageAds ()
	{
		localStorage.setItem( this.adsName, JSON.stringify( this.ads ) );
	}


	/**
	 * This version doesn't care about dates / how long ago it was
	 *
	 * @param adId
	 * @return {boolean}
	 */
	hasSeenAd ( adId )
	{
		if ( typeof this.ads === 'undefined' )
		{
			this.getLocalStorageAds();
		}

		return typeof this.ads.find( ad => ad.id === adId ) !== 'undefined';
	}

	shouldShowAd ( adId, delayBeforeShowingAgainInHrs = this.delayBeforeShowingAgain )
	{
		if ( typeof this.ads === 'undefined' )
		{
			this.getLocalStorageAds();
		}

		const foundAd = this.ads.find( ad => ad.id === adId );

		if ( typeof foundAd === 'undefined' )
		{
			return true;
		}

		const timeSinceShowing  = Math.abs( Date.now() - foundAd.date );
		const hoursSinceShowing = timeSinceShowing / (1000 * 60 * 60);

		return hoursSinceShowing > this.delayBeforeShowingAgain;

	}

	markAdAsSeen ( adId )
	{
		if ( typeof this.ads === 'undefined' )
		{
			this.getLocalStorageAds();
		}

		const ad = {
			id   : adId,
			seen : Date.now(),
		};

		const foundAdIndex = this.ads.findIndex( ad => ad.id === adId ) > -1;

		// add the ad to the seen ads
		if ( foundAdIndex )
		{
			this.ads[ foundAdIndex ] = ad;
		} else
		{
			// let's update the seen date.
			// No use in storing multiple viewings of the same ad
			this.ads.push( ad );
		}

		this.saveLocalStorageAds();
	}

}
